import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
    CssBaseline,
    Dialog,
    DialogContent,
    DialogContentText,
    useMediaQuery,
} from "@mui/material/";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import actions from "../../../Store/actions";
import { useAuthenticated } from "../../hooks";
import { useTranslation } from "react-i18next";
import LoginForm from "../LoginForm";
import Toaster from "../Toaster";
import UserMenu from "../../../User/UserMenu";
import styles from "./styles";
import menuUtils from "../../../User/UserMenu/menuUtils";

type Props = {
    children: React.ReactNode,
};

/**
 * App Screen Component
 * @param {Props} props
 */

export default ({ children }: Props) => {
    const { t } = useTranslation();
    const location = useLocation();
    const title = menuUtils.screenTitle(location.pathname);

    const [anchorEl, setAnchorEl] = useState(null);
    const { appSettings } = useSelector((state) => state);
    const classes = makeStyles(styles)();
    const dispatch = useDispatch();
    const { hasIdToken } = useAuthenticated();
    const [loginDialogOpen, setLoginDialogOpen] = useState(false);
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.down("xl"));

    const { drawerOpen } = appSettings;

    const onDrawerClose = () =>
        dispatch(
            actions.appSettings.create.set({
                drawerOpen: false,
            })
        );

    const onLoginDialogClose = () => setLoginDialogOpen(false);
    const onLoginDialogOpen = () => setLoginDialogOpen(true);

    const onMenuClose = () => setAnchorEl(null);
    const onMenuOpen = (event: Event) => setAnchorEl(event.currentTarget);

    const onLoginFormSuccess = () => {
        setLoginDialogOpen(false);
        window.location.reload();
    };

    useEffect(() => {
        xsDown && onDrawerClose();
    }, [xsDown]);

    return (
        <>
            <CssBaseline />
            <Dialog onClose={onLoginDialogClose} open={loginDialogOpen}>
                <DialogContent>
                    <DialogContentText>
                        {t("messages.enterCredentials")}
                    </DialogContentText>
                    <LoginForm onSuccess={onLoginFormSuccess} />
                </DialogContent>
            </Dialog>

            {hasIdToken && (
                <UserMenu
                    anchorEl={anchorEl}
                    onClose={onMenuClose}
                    open={Boolean(anchorEl)}
                />
            )}
            {/* TODO: FIND a better way to make content static/scrollable */}
            <div
                id="screen-outer-wrp"
                className={
                    title === "audits/assets/details"
                        ? classes.contentScrollableWrp
                        : classes.contentStaticWrp
                }
            >
                {children}
            </div>
            <Toaster />
        </>
    );
};
